
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[location]/listings/[page]",
      function () {
        return require("private-next-pages/[location]/listings/[page].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[location]/listings/[page]"])
      });
    }
  